import { Component, OnInit, Input } from '@angular/core';

import { AuthService } from './../services/auth.service';
import { LanguageService } from './../rest/api/language.service';
import * as _ from 'lodash';
import { PageService } from '../rest/api/page.service';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() showMemberHeader;
  @Input() showPublicHeader;
  @Input() showAuthHeader;
  @Input() showSettingsRoute;
  @Input() userData;
  @Input() isLoggedIn;

  menuList: any;
  currentUrl = '';
  lang: any;


  rla: any;
  rla1: any;
  rla2: any;
  rla3: any;

  defaultLanguage: any;
  languageData: any;

  companyRoles: any;

  constructor(
    public authService: AuthService,
    public languageService: LanguageService,
    public pageService: PageService,
    public translateService: TranslateService
  ) {
    this.authService.companyRoles.subscribe((value) => {
      this.companyRoles = value;
    });
  }

  getConfig() {
    this.languageService.getLanguages().subscribe((response: any) => {
      this.languageData = response && response.data ? response.data : [];
      if (localStorage.getItem('language')) {
          this.defaultLanguage = this.languageData ? _.find(this.languageData, (o) => {
            return o && o.short_code === localStorage.getItem('language');
          }) : undefined;
          if (!this.defaultLanguage) {
            this.defaultLanguage = _.find(this.languageData, (o) => {
              return o.default === 1;
            });
          }
          this.translateService.setDefaultLang(this.defaultLanguage.short_code);
          this.translateService.use(this.defaultLanguage.short_code);
      } else {
          this.defaultLanguage = _.find(this.languageData, (o) => {
            return o.default === 1;
          });
          this.translateService.setDefaultLang(this.defaultLanguage.short_code);
          this.translateService.use(this.defaultLanguage.short_code);
          localStorage.setItem('language', this.defaultLanguage.short_code);
      }
    });
  }

  ngOnInit() {
    this.getConfig();
    this.lang = this.translateService.currentLang ? this.translateService.currentLang :
    (localStorage.getItem('language') ? localStorage.getItem('language') : '');
    this.getAllMenu();
  }

  getAllMenu() {
    this.pageService.getMenuList(this.lang).subscribe((response: any) => {
     let menuList = response && response.data ? response.data : [];
     menuList = _.filter(menuList, {show_in_menu: 1});
     this.menuList = _.orderBy(menuList, ['show_in_menu'], ['desc']);
   }, err => {
     console.log(err && err.error);
   });
  }

  changeLanguage(code) {
    this.defaultLanguage = _.find(this.languageData, (o) => {
      return o.short_code === code;
    });
    if (this.defaultLanguage) {
      this.translateService.setDefaultLang(this.defaultLanguage.short_code);
      this.translateService.use(this.defaultLanguage.short_code);
      localStorage.setItem('language', this.defaultLanguage.short_code);
      window.location.reload();
    }
  }

  logout() {
    this.authService.logout();
    window.location.href = '/login';
  }

}
